<template>
  <div>
    <v-layout wrap>
        <v-flex xs12>
            <v-layout wrap justify-center>
                <v-flex xs9 text-left pt-4>
                    <v-layout wrap>
                        <v-flex xs12 px-3>
                          <span class="hd">Cart>Information>Shipping>Payment</span> 
                        </v-flex>
                    </v-layout>
                  <v-layout wrap>
                    <v-flex md6 pb-3>
                    <v-card elevation="1">
                        <v-layout wrap px-3>
                            <v-flex md6>
                               <v-flex xs12 pt-3>
                            <span class="hd1">Contact Information</span>
                        </v-flex>
                            </v-flex>
                            <v-flex md6>
                                 <v-flex xs12 pt-5>
                            <span class="hd">Already Have an Account?</span>
                            <span class="log"> Log in</span>
                        </v-flex>
                            </v-flex>
                            <v-flex xs12 pt-5 px-3>
                                <v-text-field color="grey" outlined dense label="Email"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout wrap>
                                    <v-flex xs1>
                                     <v-checkbox>

                                    </v-checkbox>
                                    </v-flex>
                                    <v-flex xs11>
                                        <span>Keep me sign in</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <span><strong>Shipping Address</strong></span>
                            </v-flex>
                            <v-flex xs12>
                                <v-form>
                                    <v-layout wrap pt-3>
                                        <v-flex xs6 px-2>
                                         <v-text-field dense outlined color="grey" label="First name">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                         <v-text-field dense outlined color="grey" label="Last name">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 px-2>
                                        <v-text-field dense outlined color="grey" label="Company(optional)">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 px-2>
                                        <v-text-field dense outlined color="grey" label="Address">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 px-2>
                                        <v-text-field dense outlined color="grey" label="Appartment, Suit, etc">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 px-2>
                                        <v-text-field dense outlined color="grey" label="City">

                                         </v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-layout wrap>
                                             <v-flex xs4 px-2>
                                                <v-text-field dense outlined color="grey" label="Country">

                                                </v-text-field>
                                                </v-flex>
                                                <v-flex xs4 px-2>
                                                <v-text-field dense outlined color="grey" label="State">

                                                </v-text-field>  
                                                </v-flex>
                                                <v-flex xs4 px-2>
                                                <v-text-field dense outlined color="grey" label="Pin">

                                                </v-text-field> 
                                                </v-flex>  
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 px-2>
                                            <v-text-field dense outlined label="Phone"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 pl-2>
                                            <v-layout wrap>
                                                <v-flex xs1>
                                                <v-checkbox></v-checkbox>
                                                </v-flex>
                                                <v-flex xs11>
                                                    <span><strong>Save this Information for next time.</strong></span>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </v-card>
                    </v-flex>
                    <v-flex md6 pl-md-8>
                         <v-layout wrap>
                            <v-flex xs12>
                                <v-card elevation="3">
                                <v-layout wrap pa-3>
                                    <v-flex xs12>
                                        <span class="hd1">Cart</span>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout wrap v-for="(item,i) in cart" :key="i">
                                            <v-flex xs4 px-3>
                                                <v-img 
                                                :src="require('../../assets/Images/' + item.image)"
                                                >
                                                </v-img>
                                            </v-flex>
                                            <v-flex xs8 >
                                                <span class="cart">ABC Indoor Plant</span><br>
                                                <span class="hd">Indoor plant</span><br>
                                                <span class="hd">Qty:1</span><br>
                                                <span><v-icon x-small>mdi-currency-inr</v-icon>
                                                <strong>280</strong>
                                                &nbsp; <span class="old"><strike>340</strike></span>
                                                </span>
                                            </v-flex>
                                            <v-flex xs12 py-3>
                                                <v-divider></v-divider>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout wrap>
                                            <v-flex xs12 text-left>
                                        <span class="total">TOTAL</span>
                                        </v-flex>
                                        <v-flex xs12 text-left pt-4>
                                            <span class="price">Rs. 1500</span>
                                        </v-flex>
                                        <v-flex xs12 text-left>
                                            <span class="sub">Shipping&taxes Calculated at checkout</span>
                                        </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                </v-card>
                            </v-flex>
                         </v-layout>
                     <v-layout wrap>
                        <v-flex xs12 pt-8>
                            <v-layout wrap>
                                <v-flex xs12 sm6 lg6 py-3>
                                <v-btn dark width="230px" color="#3EA56E">CONTINUE SHIPPING</v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 lg6 py-3>
                                <v-btn  outlined width="230px" >RETURN TO CART</v-btn>   
                                </v-flex>
                            </v-layout>
                        </v-flex>
                     </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
   data(){
    return{
        cart:[
            {
          image: "c2.png",
          title: "Bonsai",
          price: "80/kg",
        },
        {
          image: "c7.png",
          title: "Bonsai",
          price: "80/kg",
        },
        {
          image: "c4.png",
          title: "Bonsai",
          price: "80/kg",
        },
        ]
    }
   }
}
</script>

<style scoped>
.hd{
    color: grey;
}
.hd1{
  color: black;
  font-size: 25px;
  font-weight: bold;
}
.log{
    color: green;
    font-weight: bold;
    font-size: 17px;
}
.cart{
    color: black;
    font-weight: bold;
    font-size: 16px;
}
.total{
    color: grey;
    font-size: 16px;
    letter-spacing: 2px;
}
.price{
    font-size: 20px;
    font-weight: bolder;
}
.old{
    color: grey;
}
 .sub{
    font-size: 13px;
    color: grey;
  }
</style>